import React from "react";

interface ButtonProps {
  onClick: () => void;
  selected: boolean;
  children: React.ReactNode;
}

const CommonButton: React.FC<ButtonProps> = ({
  onClick,
  selected,
  children,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        margin: "5px",
        border: selected ? "2px solid #000" : "1px solid #ccc",
        fontSize: "14px",
      }}
    >
      {children}
    </button>
  );
};

export default CommonButton;
